import { ICreateSendCustomMessageState } from '../types/createSendCustomMessage';

export const DEFAULT_CREATE_SEND_CUSTOM_MESSAGE_STATE: ICreateSendCustomMessageState = {
  enabled: false,
  templateId: null,
  message: '',
};
